export default __webpack_public_path__ + "static/media/exclaimation.f10076c2.svg";